import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';

export default function MvHero() {
  const { t } = useI18n();
  return (
    <section className="mv-hero">
      <div className="mv-hero__inner">
        <div className="mv-hero__copy">
          <div className="mv-kicker">{t('videoGeneration.mv.hero.kicker')}</div>
          <h1>{t('videoGeneration.mv.hero.title')}</h1>
          <p>{t('videoGeneration.mv.hero.desc')}</p>
          <div className="mv-hero__tags">
            {t('videoGeneration.mv.hero.tags').map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </div>
        <div className="mv-hero__visual">
          <div className="mv-record"><span /></div>
          <div className="mv-lyric-card">
            <strong>{t('videoGeneration.mv.hero.cardTitle')}</strong>
            <p>{t('videoGeneration.mv.hero.cardText')}</p>
          </div>
          <div className="mv-wave" />
        </div>
      </div>
    </section>
  );
}
